<template>
  <div v-loading="exportLoading || pageloading" class="yxtbiz-enroll-manage">
    <!-- 头部 -->
    <manage-audit-header :headerData='headerData' :qrCodeUrl="qrCodeUrl" :qr-code-text="qrCodeText" />
    <div class="yxtbiz-enroll-manage__main mt12 p24 bg-white">
      <!-- 操作按钮和搜索条件 -->
      <yxt-row type="flex" justify="space-between">
        <div class="yxtbiz-enroll-manage__main-buttons">
          <!--报名设置-->
          <yxt-button
            type="primary"
            size="large"
            @click="setApply">
            {{ $t('pc_biz_enroll_lbl_applysetting' /* 报名设置 */) }}
          </yxt-button>
          <!--添加学员-->
          <yxt-button
            plain
            size="large"
            @click="showDrawer">
            {{ $t('pc_biz_enroll_lbl_addstudent' /* 添加学员 */) }}
          </yxt-button>
          <yxt-dropdown
              custom-elm
              class="ml12"
              @command="handleMoreOpt">
              <yxt-button plain size="large">
                {{ $t('pc_biz_enroll_lbl_moreoperate' /* 更多操作 */) }}<i class="yxt-icon-arrow-down yxt-icon--right"></i>
              </yxt-button>
              <yxt-dropdown-menu slot="dropdown">
                <!-- 催促报名 -->
                <yxt-dropdown-item command="1">{{ $t('pc_biz_enroll_urgeSignupaudit', urge) /* 催促报名（） */}}</yxt-dropdown-item>
                <!-- 开启 -->
                <yxt-dropdown-item v-if='headerData.status===3' command="4">{{ $t('pc_biz_enroll_lbl_open' /* 开启 */) }}</yxt-dropdown-item>
                <!-- 暂停 -->
                <yxt-dropdown-item v-if='headerData.status===2' command="4">{{ $t('pc_biz_enroll_btn_stop' /* 暂停 */) }}</yxt-dropdown-item>
                <!-- 导出 -->
                <yxt-dropdown-item command="2">{{ $t('pc_biz_enroll_lbl_export_data' /* 导出 */) }}</yxt-dropdown-item>
              </yxt-dropdown-menu>
            </yxt-dropdown>
        </div>
        <div class="yxtbiz-enroll-manage__main-query">
          <!-- 后期可能会加 -->
          <!-- <yxt-select v-model="query.enrollType"
                      class="mr12 w144"
                      clearable
                      :placeholder="$t('pc_biz_enroll_lbl_signupWays' /* 报名方式 */)"
                      @change="handleSearch">
            <yxt-option v-for="(value, key) in enrollWays"
              :key="key"
              :label="value"
              :value="key">
            </yxt-option>
          </yxt-select> -->
          <yxt-select v-model="value"
                      class="mr12 w144"
                      clearable
                      :placeholder="$t('pc_biz_enroll_lbl_status' /* 状态 */)"
                      @change="handleSelect">
            <yxt-option v-for="item in statusMap"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
            </yxt-option>
          </yxt-select>
          <yxt-input v-model="query.fullname"
                     :placeholder="$t('pc_biz_enroll_tip_search' /* 请输入名称搜索 */)"
                     searchable
                     maxlength="50"
                     style="width: 240px;"
                     @search="handleSearch"
                     @keyup.enter.native="handleSearch"
          ></yxt-input>
        </div>
      </yxt-row>
      <!-- 表格展示数据 -->
      <yxt-table ref="table"
                 v-loading="loading"
                 :row-key="getRowKey"
                 class="mt16"
                 :data="tableData"
                 @select-all="handelSelectCurrent"
                 @select="handelSelect"
                 @selection-change="handleSelectionChange">
        <yxt-table-column
          type="selection"
          :selectable="selectable"
          class-name="yxt-o2o-selection-col"
          :reserve-selection="true"
          width="38"
          align="right"
          fixed="left"
          clear-padding="left-right">
        </yxt-table-column>
        <!--选择当前页  选择全部-->
        <select-part-or-all @handleCommand="handleCommand"></select-part-or-all>
        <yxt-table-column prop="user.fullname"
                          :label="$t('pc_biz_enroll_lbl_cnname' /* 姓名 */)"
                          fixed="left"
                          min-width="150"
                          show-overflow-tooltip>
          <template slot-scope="scope">
            <yxtbiz-user-name :name="scope.row.user.fullname" />（<yxtbiz-user-name :name="scope.row.user.username" />）
          </template>
        </yxt-table-column>
        <yxt-table-column
          v-for="item in customFields"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          min-width="120"
          show-overflow-tooltip></yxt-table-column>
        <yxt-table-column prop="user.deptName"
                          :label="$t('pc_biz_enroll_lbl_dept' /* 部门 */ )"
                          min-width="200"
                          show-overflow-tooltip>
          <template slot-scope="scope">
            <yxtbiz-dept-name :name="scope.row.user.deptName || '--'" />
          </template>
        </yxt-table-column>
        <yxt-table-column prop="user.positionNameList"
                          :label="$t('pc_biz_enroll_col_position'/* 岗位 */)"
                          min-width="120"
                          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.user.positionNameList || '--' }}</span>
          </template>
        </yxt-table-column>
        <!-- 后期可能会加 -->
        <!-- <yxt-table-column prop="enrollType"
                          :label="$t('pc_biz_enroll_lbl_signupWays' /* 报名方式 */)"
                          min-width="120"
                          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ enrollWays[scope.row.enrollType] || '--' }}</span>
          </template>
        </yxt-table-column> -->
        <yxt-table-column prop="user.mobile" :label="$t('pc_biz_enroll_lbl_phone' /* 电话 */)" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.user.mobile || '--' }}</span>
          </template>
        </yxt-table-column>
        <yxt-table-column :label="$t('pc_biz_enroll_lbl_assignedenrolltime' /* 指派/报名时间 */)" width="166">
          <template slot-scope="scope">
            {{ scope.row.createTime | date('yyyy-MM-dd hh:mm','--') }}
          </template>
        </yxt-table-column>
        <yxt-table-column :label="$t('pc_biz_enroll_lbl_status' /* 状态 */)" :min-width="$isEnglish ? 160 : 120">
          <template slot-scope="scope">
            {{ getStatus(scope.row) }}
          </template>
        </yxt-table-column>
        <yxt-table-column prop="checkUserFullname"
                          :label="$t('pc_biz_enroll_lbl_auditor' /* 审核人 */)"
                          min-width="100"
                          show-overflow-tooltip>
          <template slot-scope="scope">
            <yxtbiz-user-name :name="scope.row.checkUserFullname || '--'" />
          </template>
        </yxt-table-column>
        <yxt-table-column :label="$t('pc_biz_enroll_lbl_audittime' /* 审核时间 */)" width="166">
          <template slot-scope="scope">
            {{ scope.row.checkTime | date('yyyy-MM-dd hh:mm','--') }}
          </template>
        </yxt-table-column>
        <yxt-table-column prop="checkOpinion"
                          :label="$t('pc_biz_enroll_msg_manageaudit_lbl_remarks' /* 备注 */)"
                          min-width="150"
                          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.checkOpinion || '--' }}</span>
          </template>
        </yxt-table-column>
        <yxt-table-column :label="$t('pc_biz_enroll_lbl_operation' /* 操作 */)"
                          :width="186"
                          fixed="right"
                          align="left">
          <template slot-scope="scope">
            <yxt-button type="text" v-if="scope.row.checkStatus === 0" @click="checkEnroll(scope.row)">{{ $t('pc_biz_enroll_lbl_check' /* 审核 */) }}</yxt-button>
            <yxt-button type="text" v-else @click="viewDetail(scope.row)">{{ $t('pc_biz_enroll_lbl_detail' /* 详情 */) }}</yxt-button>
            <yxt-divider direction="vertical"></yxt-divider>
            <yxt-button v-if="scope.row.checkStatus !== 4" type="text" @click="disqualification(scope.row)">{{ $t('pc_biz_enroll_lbl_disqualification' /* 取消资格 */) }}</yxt-button>
          </template>
        </yxt-table-column>
      </yxt-table>
      <!-- 分页 -->
      <yxt-row class="mt16" type="flex" justify="end">
        <yxt-pagination :current-page="query.current"
                        :page-size="query.limit"
                        :total="totalCount"
                        layout="total, prev, pager, next, sizes, jumper"
                        simple-total
                        show-on-single-page
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange">
        </yxt-pagination>
      </yxt-row>
    </div>
    <!-- 选择添加人员 -->
    <yxt-drawer ref="drawer"
                :destroy-on-close="true"
                :visible.sync="addPersonnelRange.show"
                size="960px"
                :before-close="done => done(userSelectorIsChange)">
      <yxt-user-selector  ref="addPersonnelRange"
                          class="pb24"
                          :tabs="['persons', 'advance']"
                          :data="addPersonnelRange.value"
                          :functionCode="functionCode"
                          :dataPermissionCode="rangePermissionCode"
                          @change="handleUserSelectorChange"></yxt-user-selector>
      <div slot="footer">
        <yxt-button plain @click="closeDrawer">{{ $t('pc_biz_enroll_btn_cancle' /* 取消 */) }}</yxt-button>
        <yxt-button type="primary" @click="confirmDrawer(50)">{{ $t('pc_biz_enroll_btn_confirm' /* 确定 */) }}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
import ManageAuditHeader from './components/AuditHeader';
import SelectPartOrAll from './components/SelectPartOrAll';
import commonUtil from '../../common-util';
import {
  Row,
  Button,
  Drawer,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Select,
  Option,
  Input,
  Table,
  TableColumn,
  Divider,
  Pagination } from 'yxt-pc';
import YxtBizUserName from 'yxt-biz-pc/packages/user-name';
import YxtBizDeptName from 'yxt-biz-pc/packages/dept-name';
import YxtUserSelector from 'yxt-biz-pc/packages/user-selector';
import {
  postCheckList,
  exportCheckList,
  sendEnrollurgeMsg,
  startEnroll,
  stopEnroll,
  getEnrollSummary,
  cancelBatch,
  addStudent } from './service';
export default {
  name: 'YxtbizEnrollManage',
  components: {
    ManageAuditHeader,
    SelectPartOrAll,
    YxtRow: Row,
    YxtButton: Button,
    YxtDrawer: Drawer,
    YxtDropdown: Dropdown,
    YxtDropdownMenu: DropdownMenu,
    YxtDropdownItem: DropdownItem,
    YxtSelect: Select,
    YxtOption: Option,
    YxtInput: Input,
    YxtTable: Table,
    YxtTableColumn: TableColumn,
    YxtDivider: Divider,
    YxtPagination: Pagination,
    YxtBizUserName,
    YxtBizDeptName,
    YxtUserSelector
  },
  props: {
    orgId: String, // 机构id
    enrollId: String, // 报名id
    qrCodeUrl: String, // 二维码链接
    qrCodeText: String, // 二维码弹窗副标题文案
    functionCode: String, // 导航功能权限
    rangePermissionCode: String, // 添加学员选人权限
    masterType: { // 来源主项目类型，1：项目设计器
      type: Number,
      default: 1
    },
    customFields: { // 自定义字段
      type: Array,
      default: () => {
        return [];
      }
    },
    cancelBatchTip: String // 各业务自定义取消资格结果说明
  },
  data() {
    // 报名方式,0：自主报名，1：后台指派 ,2：代报名
    const enrollWays = {
      0: this.$t('pc_biz_enroll_lbl_signupByself' /* 自己报名 */),
      // 1: this.$t('pc_biz_enroll_lbl_admin_by' /* 后台指派 */),
      2: this.$t('pc_biz_enroll_lbl_signupByOthers' /* 学员代报名 */)
    };
    // 状态：0：待审核、1：正式学员、2：替补学员、3：审核不通过、4：放弃资格、5：取消资格
    let statusMap = [
      { value: '0', label: this.$t('pc_biz_enroll_lbl_toaudit' /* 待审核 */) },
      { value: '1', label: this.$t('pc_biz_enroll_lbl_formalstudent' /* 正式学员 */) },
      // { value: '2', label: this.$t('pc_biz_enroll_lbl_substitutestudent' /* 替补学员 */) },
      { value: '3', label: this.$t('pc_biz_enroll_lbl_auditrefuse' /* 审核不通过 */) },
      // { value: '4', label: this.$t('pc_biz_enroll_lbl_giveup' /* 放弃资格 */) },
      { value: '5', label: this.$t('pc_biz_enroll_lbl_disqualification' /* 取消资格 */) }
    ];
    return {
      enrollWays,
      statusMap,
      value: '', // 状态
      totalCount: 0,
      tableData: [],
      headerData: {
        alternateNum: null, // 替补学员人数
        endTime: null, // 报名结束时间
        formalNum: null, // 正式学员人数
        registeredNum: null, // 已报名人数
        startTime: null, // 报名开始时间
        status: null, // 状态,0：未发布（已设置），1：发布中（人员分解），2：已发布（报名中），3：已暂停，4：已结束
        waitCheckNum: null, // 待审核人数
        enrollName: '' // 报名名称
      },
      query: {
        limit: 10,
        current: 1,
        projectId: this.enrollId,
        userType: null,
        checkStatus: null,
        fullname: null,
        enrollType: null
      },
      multipleSelection: [], // 选择报名人员
      loading: false,
      pageloading: false,
      exportLoading: false,
      urge: [0, 10], // 第一个为已发催促报名次数，第二个为总的次数
      excludeIdList: [],
      tableDataMap: new Map(),
      actionAttr: 'userId',
      selectType: 1, // 数据表头下拉框选择状态，0表示选择全部，1表示非选择全部
      addPersonnelRange: {
        show: false,
        value: []
      },
      userSelectorIsChange: false // 标识userSelector组件是否发生变化
    };
  },
  mounted() {
    this.enrollInit();
  },
  filters: {
    date(date, fmt = 'yyyy-MM-dd hh:mm:ss', emptyChar = '--') {
      if (!date) return emptyChar;
      if (typeof date === 'string') {
        date = new Date(date.replace(/-/g, '/'));
      } else if (typeof date === 'number') {
        date = new Date(date);
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S': date.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)); }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
      }
      return fmt;
    }
  },
  methods: {
    // 获取页面初始数据
    async enrollInit() {
      this.pageloading = true;
      try {
        await this.getHeaderData();
      } catch (err) {
        // this.$message.error(err.error.message);
      }
      // 如果报名状态为1 就轮训过一秒再调接口
      if (this.headerData.status === 1) {
        setTimeout(() => {
          this.enrollInit();
        }, 1000);
        return;
      }
      this.getData();
    },
    // 跳转报名设置
    setApply() {
      this.$emit('setApply');
    },
    // 添加学员抽屉打开
    showDrawer() {
      this.addPersonnelRange.value = [];
      this.userSelectorIsChange = false;
      this.addPersonnelRange.show = true;
    },
    // 添加学员抽屉关闭
    closeDrawer() {
      this.$refs.drawer.closeDrawer();
    },
    // 选人组件人员变化
    handleUserSelectorChange(selectedUserList, selectedUserGroupList) {
      this.userSelectorIsChange = JSON.stringify(this.addPersonnelRange.value) !== JSON.stringify(selectedUserList) || selectedUserGroupList.length > 0;
    },
    // 确认抽屉选择
    async confirmDrawer(count) {
      try {
        // 获取选中部门或者人员
        let value = await this.$refs.addPersonnelRange.getSelected();
        if (!value || value.length === 0) {
          this.addPersonnelRange.show = false;
          return;
        }
        const temp = value instanceof Array ? (count > 0 ? value.splice(0, count) : value) : [value];
        if (count > 0 && value.length > 0) { // 超过count，只取前面几个
          this.$message.warning(this.$t('pc_biz_enroll_msg_maxnum', [count] /* 最多{0}个 */));
        }
        const params = {
          recordUrl: '',
          projectId: this.enrollId
        };
        params.recordUrl = await this.uploadEnrollRange(temp);
        addStudent(params).then(res => {
          if (res.status === 0) { // 全部添加成功
            this.$message.success(this.$t('pc_biz_enroll_msg_add_success' /* 已添加成功 */));
          } else if (res.status === 1) { // 部分添加成功
            if (res.excludeCount && res.existFailCount) { // 存在已报名添加失败人员和排除人员添加失败
              this.$message.error(this.$t('pc_biz_enroll_msg_part_exclude_exist', [res.existFailCount, res.excludeCount] /* 已添加成功 其中{0}位人员已报名，{1}位人员在排除人员名单中，无法添加 */));
            } else if (res.excludeCount) { // 只存在排除人员添加失败
              this.$message.error(this.$t('pc_biz_enroll_msg_part_exclude', [res.excludeCount] /* 已添加成功 其中{0}位人员在排除人员名单中，无法添加 */));
            } else { // 只存在已报名人员添加失败
              this.$message.error(this.$t('pc_biz_enroll_msg_part_exist', [res.existFailCount] /* 已添加成功 其中{0}位人员已报名，无法添加 */));
            }
          } else { // 没有添加成功
            if (res.excludeCount && res.existFailCount) { // 存在已报名添加失败人员和排除人员添加失败
              this.$message.error(this.$t('pc_biz_enroll_msg_fail_exclude_exist', [res.existFailCount, res.excludeCount] /* {0}位人员已报名，{1}位人员在排除人员名单中，无法添加 */));
            } else if (res.excludeCount) { // 只存在排除人员添加失败
              this.$message.error(this.$t('pc_biz_enroll_msg_fail_exclude', [res.excludeCount] /* {0}位人员在排除人员名单中，无法添加 */));
            } else { // 只存在已报名人员添加失败
              this.$message.error(this.$t('pc_biz_enroll_msg_fail_exist', [res.existFailCount] /* {0}位人员已报名，无法添加 */));
            }
          }
          this.query.current = 1;
          this.getData();
          this.tableDataMap = new Map();
          this.clearSelectList();
        }).catch(err => {
          this.$message.error(err.error.message);
        });
        this.addPersonnelRange.show = false;
      } catch (err) {
        this.$message.error(err.message);
      }
    },
    // 上传添加学员到oss
    async uploadEnrollRange(personnelRange) {
      // const ossConfig = await getSts();
      // if (!ossConfig || !ossConfig.securityToken) {
      //   throw new Error('getSts error!');
      // }

      const ossData = { // oss上传数据
        rangeList: []
      };
      for (const e of personnelRange) {
        ossData.rangeList.push({
          objId: e.id,
          objName: e.fullname,
          objType: 5
        });
      }
      return JSON.stringify(ossData);
      // try {
      //   const fileName = `${ossConfig.uploadPath}/c${this.masterType}-${this.enrollId}/${new Date().getTime()}-${~~(Math.random() * 1000000)}.json`; // 定义唯一的文件名
      //   // oss客户端
      //   const OSS = require('ali-oss');
      //   const ossClient = new OSS({
      //     region: ossConfig.region,
      //     secure: window.location.protocol === 'https:',
      //     accessKeyId: ossConfig.accessKeyId,
      //     accessKeySecret: ossConfig.accessKeySecret,
      //     stsToken: ossConfig.securityToken,
      //     bucket: ossConfig.bucket
      //   });
      //   const result = await ossClient.put(fileName, new OSS.Buffer(JSON.stringify(ossData)));
      //   return ossConfig.prefix + result.name;
      // } catch (ex) {
      //   throw ex;
      // }
    },
    // 更多操作
    handleMoreOpt(val) {
      switch (val) {
        case '1':
          this.urgeSignupaudit();
          break;
        case '2':
          this.exportData();
          break;
        case '4':
          this.changeEnrollStatus();
          break;
        default:
          break;
      }
    },
    // 催促报名
    async urgeSignupaudit() {
      if (this.urge[0] >= this.urge[1]) {
        this.$message.error(this.$t('pc_biz_enroll_urge_zero' /* 您剩余的催促次数为0 */));
        return;
      }
      if (this.urgeStuTimer) clearTimeout(this.urgeStuTimer);
      const callNow = !this.urgeStuTimer;
      this.urgeStuTimer = setTimeout(() => {
        this.urgeStuTimer = null;
      }, 1500);
      if (callNow) {
        try {
          const res = await sendEnrollurgeMsg({ projectId: this.enrollId, orgId: this.orgId });
          this.urge = [res.data, 10];
          this.$message({
            message: this.$t('pc_biz_enroll_urge_remain' /* 已催促报名，您剩余的催促次数为{0} */, [10 - res.data]),
            type: 'success'
          });
        } catch (err) {
          this.$message.error(err.message);
        }
      }
    },
    // 导出数据
    exportData() {
      if (!this.tableData.length) {
        // 若无数据，则吐司提示：暂无数据
        this.$message.error(this.$t('pc_biz_enroll_tip_nodatas' /* 暂无数据 */));
      } else {
        this.exportLoading = true;
        let params = {
          projectId: '',
          userType: '',
          checkStatus: '',
          fullname: '',
          enrollType: ''
        };
        Object.keys(params).forEach(ele => {
          params[ele] = this.query[ele];
        });
        params.orgId = this.orgId;
        params.userId = localStorage.getItem('userId');
        params.locale = localStorage.getItem('yxtLang') || commonUtil.getLanguage();
        params.userFullName = localStorage.getItem('username');
        exportCheckList(params).then(res => {
          this.downloadFile();
        }).finally(() => {
          this.exportLoading = false;
        });
      }
    },
    // 下载文件
    downloadFile() {
      this.$confirm(this.$t('pc_biz_enroll_lbl_filedownloading' /* 正在下载导出文件，请在下载中心查看 */), this.$t('pc_biz_enroll_lbl_viewexportfile' /* 查看导出文件 */), {
        confirmButtonText: this.$t('pc_biz_enroll_lbl_view' /* 查看 */),
        cancelButtonText: this.$t('pc_biz_enroll_cancel_btn' /* 取消 */),
        type: 'success'
      }).then(() => {
        let href = window.location.origin + '/down/#/download';
        window.open(href, '_blank');
      }).catch(() => {
      });
    },
    // 报名开启/暂停
    changeEnrollStatus() {
      if (this.headerData.status === 2) {
        // 当前是开启
        this.$confirm('', this.$t('pc_biz_enroll_confirm_stop' /* 确定要暂停报名吗？*/), {
          confirmButtonText: this.$t('pc_biz_enroll_confirm_btn' /* 确定*/),
          cancelButtonText: this.$t('pc_biz_enroll_cancel_btn' /* 取消*/),
          type: 'warning'
        }).then(() => {
          stopEnroll(this.enrollId).then(res => {
            this.$message.success(this.$t('pc_biz_enroll_msg_stopsuccess'/* 暂停成功 */));
            this.getHeaderData();
          }).catch(err => {
            this.$message.error(err.message);
          });
        });
      }
      if (this.headerData.status === 3) {
        // 当前是暂停
        startEnroll(this.enrollId).then(res => {
          this.$message.success(this.$t('pc_biz_enroll_msg_startsuccess'/* 开启成功 */));
          this.getHeaderData();
        }).catch(err => {
          this.$message.error(err.message);
        });
      }
    },
    // 状态转化
    handleSelect(val) {
      // val 0：待审核、1：正式学员、2：替补学员、3：审核不通过、4：放弃报名、5：取消资格
      // userType 0：非学员，1：替补学员，2：正式学员
      // checkStatus 0：待审核，1：通过，2：不通过，3:放弃资格，4：取消资格
      switch (val) {
        case '':
          this.query.userType = null;
          this.query.checkStatus = null;
          break;
        case '0':
          this.query.userType = null;
          this.query.checkStatus = 0;
          break;
        case '1':
          this.query.userType = 2;
          this.query.checkStatus = 1;
          break;
        case '2':
          this.query.userType = 1;
          this.query.checkStatus = 1;
          break;
        case '3':
          this.query.userType = null;
          this.query.checkStatus = 2;
          break;
        case '4':
          this.query.userType = null;
          this.query.checkStatus = 3;
          break;
        case '5':
          this.query.userType = null;
          this.query.checkStatus = 4;
          break;
        default:
          break;
      }
      this.query.current = 1;
      this.tableDataMap = new Map();
      this.clearSelectList();
      this.getData();
    },
    // 获取报名状态
    getStatus(row) {
      // checkStatus 0：待审核，1：通过，2：不通过，3:放弃资格，4：取消资格
      // userType 0：非学员，1：替补学员，2：正式学员
      // value 0：待审核、1：正式学员、2：替补学员、3：审核不通过、4：放弃报名、5：取消资格
      switch (row.checkStatus) {
        case 0:
          return this.$t('pc_biz_enroll_lbl_toaudit' /* 待审核 */);
        case 1:
          if (row.userType === 1) {
            return this.$t('pc_biz_enroll_lbl_substitutestudent' /* 替补学员 */);
          } else {
            return this.$t('pc_biz_enroll_lbl_formalstudent' /* 正式学员 */);
          }
        case 2:
          return this.$t('pc_biz_enroll_lbl_auditrefuse' /* 审核不通过 */);
        case 3:
          return this.$t('pc_biz_enroll_lbl_giveup' /* 放弃资格 */);
        case 4:
          return this.$t('pc_biz_enroll_lbl_disqualification' /* 取消资格 */);
        default:
          break;
      }
    },
    // 搜索
    handleSearch() {
      this.query.current = 1;
      this.tableDataMap = new Map();
      this.clearSelectList();
      this.getData();
    },
    // 获取列表数据
    getData() {
      this.loading = true;
      postCheckList(this.query).then(res => {
        this.tableData = res.datas;
        this.totalCount = res.paging.count;
        if (this.selectType === 0) {
          this.checkSelectStatus(this.tableData, this.actionAttr);
        }
      }).catch(() => {
        this.tableData = [];
        this.totalCount = 0;
      }).finally(() => {
        this.loading = false;
        this.pageloading = false;
      });
    },
    // 获取头部数据
    async getHeaderData() {
      try {
        let res = await getEnrollSummary(this.enrollId, this.orgId);
        let result = res || this.headerData;
        this.urge[0] = res.urgeNum;
        Object.keys(this.headerData).forEach(ele => {
          this.headerData[ele] = result[ele];
        });
      } catch (err) {
        this.$message.error(err.error.message);
      }
    },
    // 表格数据设置key
    getRowKey(row) {
      return row[this.actionAttr];
    },
    // 选择当页全部
    handelSelectCurrent(val) {
      this.multipleSelection = val;
      // 当页数据与已选中数据进行对比，包含则是选中， 不包含则是取消
      let mulIdList = this.multipleSelection.map(item => item[this.actionAttr]) || [];
      let curIdList = this.tableData.map(item => item[this.actionAttr]) || [];
      let pageIsSelAll = curIdList.length > 0 && mulIdList.length > 0 && mulIdList.includes(curIdList[0]);
      // 取消选中当页，将该页数据添加到删除数组中，反之，在删除列表中选中的

      if (!pageIsSelAll) {
        this.excludeIdList = [...this.excludeIdList, ...curIdList];
      } else {
        this.tableData.forEach(item => {
          if (this.excludeIdList.includes(item[this.actionAttr])) {
            this.excludeIdList = this.excludeIdList.filter(sitem => sitem !== item[this.actionAttr]);
          }
        });
      }
    },
    // 选择变化时触发
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 选择当前页 | 全部 | 清除全部
    handleCommand(command) {
      // 每次切换之前先清空数据
      this.tableDataMap = new Map();
      this.clearSelectList();
      if (command === 'delAll') {
        this.selectType = 1;
        this.multipleSelection = [];
      } else {
        this.selectType = command === 'current' ? 1 : 0;
        this.multipleSelection = this.tableData;
        this.checkSelectStatus(this.multipleSelection, this.actionAttr);
      }
    },
    // 设置选中项
    checkSelectStatus(lists, attr) {
      if (!lists || lists.length < 1) return;
      lists.forEach(list => {
        // 如果当页数据已经加载过了
        if (this.tableDataMap.has(list[attr])) {
          // 如果之前点了取消了，再回来，该项设置取消
          if (this.excludeIdList.includes(list[attr])) {
            this.$refs.table.toggleRowSelection(list, false);
          }
        } else {
          // 如果该页未加载过，均选中
          this.$refs.table.toggleRowSelection(list, true);
        }
        this.tableDataMap.set(list[attr], list);
      });
    },
    // 选中/取消某一项
    handelSelect(selection, row) {
      if (this.selectType === 0) {
        // selection 包含row的这一项，是选中，反之是取消
        let getSelectIdList = selection.map(item => item[this.actionAttr]);
        if (!getSelectIdList.includes(row[this.actionAttr])) {
          this.excludeIdList.push(row[this.actionAttr]);
        } else {
          this.excludeIdList = this.excludeIdList.filter(item => item !== row[this.actionAttr]);
        }
      }
      this.multipleSelection = selection;
    },
    // 清空选择的数据
    clearSelectList() {
      this.multipleSelection = [];
      this.excludeIdList = [];
      this.selectType = 1;
      this.$refs.table && this.$refs.table.clearSelection();
    },
    // 单页数量变化
    handleSizeChange(val) {
      this.query.limit = val;
      this.getData();
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.current = val;
      this.getData();
    },
    // 查看详情
    viewDetail(row) {
      this.$emit('viewDetail', row);
    },
    // 审核报名
    checkEnroll(row) {
      this.$emit('checkEnroll', row);
    },
    // 取消资格
    disqualification(row) {
      this.$confirm(this.cancelBatchTip, this.$t('pc_biz_enroll_confirm_cancel' /* 确认要取消资格吗？*/), {
        confirmButtonText: this.$t('pc_biz_enroll_confirm_btn' /* 确定*/),
        cancelButtonText: this.$t('pc_biz_enroll_cancel_btn' /* 取消*/),
        type: 'warning'
      }).then(() => {
        const params = {
          userIds: [row.userId],
          projectId: this.enrollId
        };
        cancelBatch(params).then(res => {
          this.query.current = 1;
          this.tableDataMap = new Map();
          this.clearSelectList();
          this.getData();
        }).catch(err => {
          this.$message.error(err.message);
        });
      });
    }
  }
};
</script>
